// Import externích knihoven
import Swiper from 'swiper/bundle';
import * as bootstrap from 'bootstrap';

// Import stylů
import 'swiper/css/bundle';
import './scss/index.scss';

// Import vlastních skriptů
import './js/alert';
import './js/lib/fontawsome';
import './js/animate-button';
import './js/ajax';
import './js/modal';
import './js/form-manipulation';
import './js/tooltip';
import './js/layout';
import './js/mobile-menu';
import './js/header-search';
import './js/lib/tom-select';
import './js/lightbox';
import './js/share';
import './js/mega-menu';
import './js/section-submenu';
import './js/form-helpers';
import './js/form-persistence';
import './js/article-card-clamp';
// import './js/air-date-picker';

// Inicializace Swiper
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.swiper').forEach((el) => {
        if (el) {
            const slides = el.querySelectorAll('.swiper-slide');
            if (slides.length > 1) {
                const options = el.dataset.swiper ? JSON.parse(el.dataset.swiper) : {}
                new Swiper(el, options)
            }
        }
    });

    document.querySelectorAll('.alert-dismissible').forEach((el) => {
        setTimeout(() => {
            el.style.transition = 'opacity 0.4s ease';
            el.style.opacity = '0';
            setTimeout(() => el.remove(), 400);
        }, 5000);
    });
})

if (!window.bootstrap) {
    window.bootstrap = bootstrap;
}

